import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-42-siddharth-mayur-guest.webp";
import ThumbImg from "../../assets/images/conversations/042.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: sy-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .sy-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .sy-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .sy-hero { padding-top: 60px; padding-bottom: 60px; }
  .sy-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .sy-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .sy-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sy-hero__title.sy-visible { opacity: 1; transform: translateY(0); }
  .sy-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .sy-hero__spotify.sy-visible { opacity: 1; transform: translateY(0); }
  .sy-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .sy-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .sy-hero__right.sy-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .sy-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .sy-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .sy-yt-thumb:hover img { opacity: 0.85; }
  .sy-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .sy-yt-thumb__play img { width: 40px; height: 44px; }
  .sy-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .sy-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .sy-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sy-body.sy-visible { opacity: 1; transform: translateY(0); }
  .sy-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .sy-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .sy-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sy-guest.sy-visible { opacity: 1; transform: translateY(0); }
  .sy-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .sy-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .sy-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .sy-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .sy-inner { padding-left: 32px; padding-right: 32px; }
    .sy-hero { padding-top: 32px; padding-bottom: 48px; }
    .sy-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .sy-hero__title { font-size: 24px; }
    .sy-hero__left { gap: 16px; }
    .sy-guest__title { font-size: 24px; margin-bottom: 24px; }
    .sy-guest__photo-bg { width: 260px; height: 300px; }
    .sy-guest__name { font-size: 24px; margin-top: 18px; }
    .sy-body__para { font-size: 14px; margin-bottom: 12px; }
    .sy-body { padding-bottom: 48px; }
    .sy-guest { padding-bottom: 48px; }
    .sy-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .sy-inner { padding-left: 16px; padding-right: 16px; }
    .sy-hero { padding-top: 51px; padding-bottom: 30px; }
    .sy-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .sy-hero__left { gap: 30px; }
    .sy-hero__title { font-size: 30px; }
    .sy-body__para { font-size: 16px; margin-bottom: 10px; }
    .sy-guest__title { font-size: 30px; margin-bottom: 20px; }
    .sy-guest__photo-bg { width: 100%; height: 386px; }
    .sy-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .sy-body { padding-bottom: 30px; }
    .sy-guest { padding-bottom: 30px; }
    .sy-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sy-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "7jpqlVHE6t0";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="sy-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 42 Siddharth Mayur"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="sy-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 42 Siddharth Mayur thumbnail" />
      <div className="sy-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="sy-hero">
      <div className="sy-inner">
        <div className="sy-hero__grid">
          <div className="sy-hero__left">
            <h1 ref={titleRef} className="sy-hero__title">
              EP 42 | The ABCs of Green Hydrogen | H2e Power | Siddharth Mayur
            </h1>
            <div ref={spotifyRef} className="sy-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5djVGpMPvEPx8Ud4uocodX?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 42 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="sy-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sy-body">
      <div className="sy-inner">
        <p className="sy-body__para">
          Hydrogen is considered an energy source for mobility worldwide. However, it's essential to note that green hydrogen derives from solar, wind, or hydro power energy sources. It goes beyond just mobility and plays a crucial role in the energy transition by decarbonizing large manufacturing processes, particularly in industries like steel, cement, and paper that rely on gas for their furnaces. Additionally, hydrogen can contribute to achieving energy independence, especially for countries like India. Today, we are speaking with Siddharth Mayur, the founder and CEO of H2e Power, India's first green energy electrolyser and fuel cell company with operations in India, Germany, and the USA.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sy-guest">
      <div className="sy-inner">
        <h2 className="sy-guest__title">Our Guest</h2>
        <div>
          <div className="sy-guest__photo-bg">
            <img src={GuestImg} alt="Siddharth Mayur" />
          </div>
          <p className="sy-guest__name">Siddharth Mayur</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep42SiddharthMayur() {
  return (
    <>
      <style>{CSS}</style>
      <div className="sy-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}